<template>
  <sideBarView />

  <navbarView />

  <main class="main-sec" id="main">
    <div class="container">
      <div class="flex-bet-main mb-4">
        <div class="side-heading">
          <h6>{{ $t('manageMessage.title') }}</h6>
        </div>
      </div>
      <div class="card-details-def">
        <p class="main-p">
         {{ $route.query.text }}
        </p>
      </div>
    </div>
  </main>
</template>

<script setup>
// imports
import sideBarView from "../components/dashboard/sideBarView.vue";
import navbarView from "../components/dashboard/navbarView.vue";

import { onMounted } from "vue";

// reactive state

// functions

// lifecycle hooks
onMounted(() => {
  // console.log(`mounted`);
});
</script>
